import { render, staticRenderFns } from "./helm.cattle.io.projecthelmchart.vue?vue&type=template&id=ba33cdd4&scoped=true&"
import script from "./helm.cattle.io.projecthelmchart.vue?vue&type=script&lang=js&"
export * from "./helm.cattle.io.projecthelmchart.vue?vue&type=script&lang=js&"
import style0 from "./helm.cattle.io.projecthelmchart.vue?vue&type=style&index=0&id=ba33cdd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba33cdd4",
  null
  
)

export default component.exports